export default "__VITE_ASSET__sBjorWbo__"